export default function filterColumn(columns) {
  if (columns === void 0) {
    columns = [];
  }
  return columns.filter(function (item) {
    return item.hidden !== true;
  });
}